{
  "0c4364b5f1989d27": "Do you want to retry payment for this shift?",
  "19766ed6ccb2f4a3": "Cancel",
  "218c6f564365c23d": "Payment retry initiated successfully",
  "4967348989ea35bf": "Retry payment",
  "49e96d7cdf58069c": "Amount",
  "57b09b76d1bb7fac": "We've successfully submitted your retry request. It may take a few minutes to process and reflect here.",
  "5ad3dbd1242a4cea": "Got it",
  "60e079d861dd6462": "Failed to retry payment",
  "99c40ab405926cb5": "Date",
  "aedeb39deae676eb": "Payment retry submitted",
  "e67e2941567ee80c": "Retry shift payment",
  "ee0f0495791d4693": "Shift ID"
}
